// extracted by mini-css-extract-plugin
module.exports = {"meal":"meal_meal__2o1sS","customLinks":"meal_customLinks__3V1y1"};